/* Generated by scripts/game_player/generate.mjs; role: lifecycle */
import { NATIVE_GAME_WINDOW_POLICY as GAME_PLAYER_POLICY } from '../policy/nativeGameWindow.policy';
// Closing a WindowProxy while its navigation commits can strand a live child.
// Retire its provider document first; the inert local document closes itself
// after load. One pending resource blocks named-window reuse and app reload.
export const createNativeGameWindowClose = (win = window) => {
  let pending = null;
  const nativeClose = popup => {
    try { popup?.close?.(); return popup?.closed ? 'closed' : 'pending'; }
    catch { return 'failed'; }
  };
  const finish = ticket => {
    if (pending !== ticket) return;
    pending = null;
    win.clearTimeout(ticket.timer);
    win.removeEventListener('message', ticket.receive);
    if (ticket.url) win.URL.revokeObjectURL(ticket.url);
    win.dispatchEvent(new win.CustomEvent('gameLaunchSettled'));
  };
  const isClosing = () => {
    if (pending?.popup.closed) finish(pending);
    return Boolean(pending);
  };
  const close = (popup, { manual = false } = {}) => {
    if (!popup || popup.closed) return 'closed';
    if (isClosing()) return 'pending';
    const ticket = { popup, url: null, timer: null, receive: null };
    // Capability failures still own a live resource until actual close ACK.
    // Capture it before any native call, which may reenter the launch owner.
    pending = ticket;
    // Disowned cross-origin windows require user close; retain only the fence.
    if (manual) return 'pending';
    const fallback = () => {
      const result = nativeClose(popup);
      if (popup.closed) finish(ticket);
      return result;
    };
    if (!win.URL?.createObjectURL || !win.Blob || !win.crypto?.randomUUID) return fallback();
    try {
      const nonce = win.crypto.randomUUID();
      const origin = win.location.origin;
      // No provider URL, credentials, account or game data enters this document.
      const message = JSON.stringify({ type: 'game-window-retired', nonce });
      const script = `addEventListener('load',()=>{const parent=opener;window.close();parent?.postMessage(${message},${JSON.stringify(origin)});},{once:true});`;
      ticket.url = win.URL.createObjectURL(new win.Blob([
        '<!doctype html><meta charset="utf-8"><title>게임 종료</title><script>' + script + '</script>',
      ], { type: 'text/html' }));
      ticket.receive = event => {
        if (pending !== ticket || event.source !== popup || event.origin !== origin ||
          event.data?.type !== 'game-window-retired' || event.data?.nonce !== nonce) return;
        if (popup.closed) finish(ticket);
      };
      win.addEventListener('message', ticket.receive);
      // One bounded fallback, never provider polling or a retry loop. If the
      // browser denies close, retain the resource until the user closes it.
      ticket.timer = win.setTimeout(() => {
        if (pending !== ticket) return;
        // A timer alone is not a navigation acknowledgement. The fallback may
        // close only our fully loaded inert document, never a moving provider.
        try {
          if (popup.document.URL === ticket.url && popup.document.readyState === 'complete') nativeClose(popup);
        } catch { /* A still-cross-origin document stays fenced until manual close. */ }
        if (popup.closed) finish(ticket);
      }, GAME_PLAYER_POLICY.nativeCloseFallbackMs);
      popup.location.replace(ticket.url);
      return 'pending';
    } catch {
      return fallback();
    }
  };
  return { close, isClosing };
};

let owner;
const getOwner = () => owner || (owner = createNativeGameWindowClose());
export const closeNativeGameWindow = (popup, options) => getOwner().close(popup, options);
export const isNativeGameWindowClosing = () => typeof window !== 'undefined' && getOwner().isClosing();
